import React, { useState } from 'react';
import PropTypes from 'prop-types';
import CustomInput from '../common/CustomInput';
import axios from 'axios';
import { API_URL } from '../../creds';
import { FaEyeSlash, FaEye } from 'react-icons/fa';
import { Link } from 'react-router-dom';
// import Logo from "../../assets/siasat-logo-2.png"

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API_URL}/userAuthLogin`, {
        username: email,
        password: password
      });

      const { access_token } = response.data;
      if (!access_token) {
        setError("No access token received");
        return;
      }

      // Call onLogin (App will store to localStorage via hook)
      onLogin(access_token);
      
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="bg-white border border-gray-400 rounded-2xl hover:shadow-[0_0px_15px_rgba(146,101,202,0.5)] shadow-[0_0px_5px_rgba(146,101,202,0.5)] p-8 w-full max-w-[450px] mx-auto">
        <div className="flex flex-col items-center gap-2 mb-6">
          {/* <img src={Logo} alt="siasat-logo" /> */}
          <h1 className="text-5xl text-gray-900 font-bold">Login!</h1>
          {error && <p className="text-red-500 text-sm">{error}</p>}
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <CustomInput
            label="Email"
            name="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
          />
          <div className="relative">
            <CustomInput
              label="Password"
              name="password"
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-12 transform -translate-y-1/2 text-gray-500 cursor-pointer">
              {showPassword ? <FaEyeSlash size={28} className='text-gray-900' /> : <FaEye size={28} className='text-gray-900' />}
            </span>
          </div>
          <button
            type="submit"
            disabled={isLoading}
            className="
                      text-xl 
                      bg-blue-600
                      text-white 
                      hover:bg-blue-400
                      font-semibold 
                      py-3 
                      px-6 
                      rounded-xl 
                      shadow-lg 
                      hover:shadow-2xl 
                      transition-all 
                      duration-300 
                      flex 
                      flex-col
                      items-center 
                      justify-between
                      gap-2
                    "
          >
            {isLoading ? 'Logging in...' : 'Login'}
          </button>
          <div className="flex justify-between mt-2 ">
            <span className='text-gray-900'>Did you forget your password?</span>
            <Link to="#" className="hover:text-blue-300 text-blue-600">
              Reset Password?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

LoginForm.propTypes = {
  onLogin: PropTypes.func.isRequired,
};

export default LoginForm;